import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "field" }
const _hoisted_2 = { class: "field__title" }
const _hoisted_3 = ["required", "name"]
const _hoisted_4 = ["value"]

import { reactive, ref, Ref } from "vue";
import { TInputType } from "@/types";

interface IProps {
  name: string;
  type?: TInputType;
  value: string | number;
  options?: { key: string; name: string | "" }[];
  required?: boolean;
  validations?: string[] | null;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AppSelect',
  props: {
    name: null,
    type: null,
    value: null,
    options: null,
    required: { type: Boolean },
    validations: null
  },
  emits: ["dataChange"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: "dataChange", value: string | number, name: string | ""): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  name: string;
  type?: TInputType;
  value: string | number;
  options?: { key: string; name: string | "" }[];
  required?: boolean;
  validations?: string[] | null;
}



const dataValue: Ref<string | number> = ref(props.value);



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", _hoisted_1, [
    _createElementVNode("legend", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _withDirectives(_createElementVNode("select", {
      required: __props.required,
      name: __props.name,
      onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('dataChange', dataValue.value, __props.name))),
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dataValue).value = $event)),
      class: "field__input"
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (option) => {
        return (_openBlock(), _createElementBlock("option", {
          key: option.key,
          value: option.key
        }, _toDisplayString(option.name), 9, _hoisted_4))
      }), 128))
    ], 40, _hoisted_3), [
      [_vModelSelect, dataValue.value]
    ])
  ]))
}
}

})